'use client';
import { datadogRum } from '@datadog/browser-rum';
import { env } from '@repo/env';
import { getBotCookies } from '@repo/utils/cookies';
import { useEffect } from 'react';

export function DataDogProvider() {
  useEffect(() => {
    const { isBot, isVerifiedBot, botScore } = getBotCookies();
    if (env.NEXT_PUBLIC_DD_APP_ID && env.NEXT_PUBLIC_DD_CLIENT_TOKEN) {
      datadogRum.init({
        applicationId: env.NEXT_PUBLIC_DD_APP_ID,
        clientToken: env.NEXT_PUBLIC_DD_CLIENT_TOKEN,
        site: 'datadoghq.com',
        service: 'banking-shopping-client',
        sessionSampleRate: 100,
        sessionReplaySampleRate: 1,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        traceSampleRate: 100,
        trackViewsManually: true,
        defaultPrivacyLevel: 'mask-user-input',
        env: env.NEXT_PUBLIC_DEPLOYABLE_ENV,
        version: env.NEXT_PUBLIC_VERCEL_GIT_COMMIT_SHA,
        allowedTracingUrls: [
          /https:\/\/banking-shopping-client-pr-\d+-production\.vercel\.stage\.nerdwallet\.biz\//,
          /https:\/\/banking-shopping-client-pr-\d+\.vercel\.stage\.nerdwallet\.biz\//,
          (url: string) => url.startsWith(env.NEXT_PUBLIC_NW_URL),
          (url: string) => url.startsWith(env.SECTION_SPECIFIC_ML_CLOUDFRONT_URL),
        ],
      });

      datadogRum.startView({
        name: window.location.pathname,
        service: 'banking-shopping-client',
      });
      datadogRum.setUserProperty('is_bot', isBot);
      datadogRum.setUserProperty('is_verified_bot', isVerifiedBot);
      datadogRum.setUserProperty('bot_score', botScore);
    }
  }, []);
  return null;
}
